import { withStylePrefix } from '../common/withStylePrefix';
import { PresenceIndicatorComponent, presenceIndicatorTemplate } from './PresenceIndicator';
import styles from './PresenceIndicator.styles.scss';
export const presenceIndicatorDefinition = {
    baseName: 'presence-indicator',
    template: presenceIndicatorTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonPresenceIndicator = PresenceIndicatorComponent.compose(presenceIndicatorDefinition);
